import React, { Component } from 'react';
import { connect } from "react-redux"
import _ from 'lodash';
import agent from '../agent'
import { Field, reduxForm, FormSection } from 'redux-form';
import ArtistPhoto from './ArtistPhoto'
import SelectComponent from './ui/SelectComponent'
import ArrayCheckbox from "./ArrayCheckbox";
import NewAgency from './NewAgency';
import classNames from 'classnames';
import AMLogo from '../assets/images/Default Agency Logo.png';

const renderSearchAgency = ({ input, className, placeholder, type, meta: { touched, error } }) => (
  	<div>
		<input {...input} placeholder={placeholder} type={type} />
		{ (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
	</div>
)

class BasicInfo extends Component {
	state = {
		enableEdit: false,
		showAgency: false,
		isNewAgency: false
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.showModal_info)
			this.setState({ enableEdit: !nextProps.showModal_info })
	}

	searchAgency = _.debounce( event => {
		if (this.state.isNewAgency)
			this.setState({ isNewAgency: !this.state.isNewAgency })
		if (event.target.value.length < 3) { return false }
		this.props.searchAgency(event.target.value, 'US');
	}, 1000)

	editRepresentation = () => {
		this.setState({ enableEdit: this.state.enableEdit ? false : true })
	}

	newAgency = (e) => {
		// e.preventDefault();
		// this.props.change('artist[company_id]', "")
		this.setState({isNewAgency: true});
	}

	onChangeRepresentation = (stateType, event, newValue) => {
		this.setState({ showAgency: newValue === 'represented' })
		// if (newValue !== 'represented') {
		// 	this.props.change('searchAgency', "")
		// 	this.props.change('agency', "")
		// 	this.props.change('artist[company_id]', "")
		// 	this.setState({isNewAgency: false})
		// 	this.props.clearAgencies()
		// }
    }

    viewProfile = () => {
    	this.props.onViewProfile()
    }

    // submit (values, dispatch, props) {
    // 	console.log('submit-basicinfo', props)
    // 	//this.setState({ enableEdit: false })
    // 	return props.onSubmit(props.handleSubmit)
    // }

	render() {
		const { handleSubmit, pristine, submitting, error, fieldDisabled,
            moveToRepresentation, artistPhoto, projectId, initialValues, agencies = [], showModal_info } = this.props
		const fix = {
			paddingLeft: '4rem'
		}

    let logo_url = AMLogo
    let name = 'Audition Magic'
    let contact_number = '- Undisclosed -'
    let email = ''

    if (initialValues.artist.agencies[0]) {
      logo_url = initialValues.artist.agencies[0].logo_url
      name = initialValues.artist.agencies[0].name
      contact_number = initialValues.artist.agencies[0].contact_number
      email = initialValues.artist.agencies[0].email
    }

		{
			return (<div className="row">
					<Field 
			          className="artist-photo-dropzone"
			          name="avatar" 
			          component={ ArtistPhoto }
			          projectid={projectId}
			          artistphoto={artistPhoto}
			          accept="image/jpeg,image/jpg,image/tiff,image/gif" 
			          multiple={ false } 
			          />
					<div id="basic-info-details" className="column medium-9 end">
						<div className="column small-12 medium-6">
							<p className="name">{initialValues.artist.first_name + ' ' + initialValues.artist.last_name}</p>
							<p>{initialValues.artist.category}</p>
							<p>{initialValues.artist.mobile_number}</p>
							<p className="end">{initialValues.artist.email}</p>
							<a onClick={this.viewProfile}>update my information</a>
						</div>
						{
							initialValues.artist.at2_agency_name == 'Freelance' ?
								<div className="column medium-4 represent">
									<p className="name">Representation: </p>
									<p>
                    FREELANCE<br/>
                    <small>(Representation can be set &nbsp;
                      <a onClick={moveToRepresentation}>here</a>)</small>
                  </p>
								</div> :
								<div className="column medium-4 represent">
									<p className="name">Primary Representation: </p>
									<img src={logo_url} alt="" />
									<p>{name}</p>
									<p>{contact_number}</p>
									<p>{email}</p>
                  <br/>
                  <p><small>(Representation can be set &nbsp;
                      <a onClick={moveToRepresentation}>here</a>)</small></p>
								</div>
						}
					</div>
				</div>)
		}
	}
}


BasicInfo = reduxForm({
	form: 'ArtistBasicInfo', // <------ same form name
  // destroyOnUnmount: false, // <------ preserve form data
  // forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(BasicInfo)

const mapStateToProps = state => ({
  initialValues: {
  	artist: {
  		first_name: state.common.artistInfo ? state.common.artistInfo.first_name : '',
  		last_name: state.common.artistInfo ? state.common.artistInfo.last_name : '',
  		mobile_number: state.common.artistInfo ? state.common.artistInfo.mobile_number : '',
  		at2_agency_name: state.common.artistInfo ? state.common.artistInfo.at2_agency_name : '',
  		email: state.common.artistInfo ? state.common.artistInfo.email : '',
  		category: state.common.artistInfo ? state.common.artistInfo.category : '',
  		agencies: state.common.artistInfo ? state.common.artistInfo.agencies : []
  	}
  },
  agencies: state.artist ? state.artist.agencies : []
});

const mapDispatchToProps = dispatch => ({
	searchAgency: (search, country) => 
  		dispatch({ type: 'SEARCH_AGENCY', payload: agent.Agency.search(search, country) })
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicInfo);



// WEBPACK FOOTER //
// ./src/components/BasicInfo.js